import { getCivicAddress, stripDiacritics } from './helper';

/**
 * Google Maps URL helpers. These are plain https links (Maps URLs API): they
 * open the Google Maps app on a phone or the website on a desktop, need no
 * API key and are not billed. Coordinates are preferred over the address text
 * because they can't be misread; every client is geocoded on save.
 */

// Google's Maps URLs accept at most 9 intermediate waypoints per link, so a
// leg is 10 stops: 9 waypoints + the destination.
export const MAX_WAYPOINTS = 9;
export const STOPS_PER_LEG = MAX_WAYPOINTS + 1;

export const stopLocation = (client) => {
    if (!client) return '';
    if (client.latitude != null && client.longitude != null) return `${client.latitude},${client.longitude}`;
    return stripDiacritics(getCivicAddress(client));
};

export const mapsSearchUrl = (client) =>
    `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(stopLocation(client))}`;

const directionsUrl = ({ origin, destination, waypoints = [] }) => {
    const parts = ['https://www.google.com/maps/dir/?api=1'];
    if (origin) parts.push(`origin=${encodeURIComponent(origin)}`);
    parts.push(`destination=${encodeURIComponent(destination)}`);
    if (waypoints.length) parts.push(`waypoints=${waypoints.map(encodeURIComponent).join('%7C')}`);
    parts.push('travelmode=driving');
    return parts.join('&');
};

/**
 * Split an ordered list of locations into navigable legs. The first leg has
 * no origin (Google starts from the driver's current position); each later
 * leg starts where the previous one ended.
 *
 * Returns [{ url, first, last }] with 1-based stop numbers for the labels.
 */
export const directionsLegs = (locations) => {
    const stops = locations.filter(Boolean);
    if (!stops.length) return [];
    const legs = [];
    let origin = null;
    let index = 0;
    while (index < stops.length) {
        const chunk = stops.slice(index, index + STOPS_PER_LEG);
        const destination = chunk[chunk.length - 1];
        const waypoints = chunk.slice(0, -1);
        legs.push({ url: directionsUrl({ origin, destination, waypoints }), first: index + 1, last: index + chunk.length });
        origin = destination;
        index += chunk.length;
    }
    return legs;
};
